<div id="managePopUp">
    <div class="modal-header">
        <h4 class="modal-title" id="modal-basic-title">{{title}}</h4>
    </div>
    <div class="modal-body">
        <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
                <p class="m-b-15" [innerHTML]="body"></p>
            </div>
        </div>
    </div>
    <div class="modal-footer">    
        <button type="button" class="btn secondary_btn" (click)="cancel()"> {{cancelBtnTxt}} </button>
        <button type="button" class="btn primary_btn order-sm-1" (click)="confirm()" > {{confirmBtnTxt}} </button> 
    </div>
</div>